
import commonOrderDialogs from "../components/common/common-order-dialogs.vue";
export default {
  components: { commonOrderDialogs }
};
